import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LeafletModule } from "@bluehalo/ngx-leaflet";
import { LeafletMarkerClusterModule } from "@bluehalo/ngx-leaflet-markercluster";
import { LeafletDrawModule } from "@bluehalo/ngx-leaflet-draw";

import { MatButton, MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatTooltipModule } from "@angular/material/tooltip";
import { TranslocoModule } from "@jsverse/transloco";

import { LorenGeofencingRoutingModule } from "./loren-geofencing-routing.module";
import { LorenMapZonesComponent } from "./components/loren-map-zones/loren-map-zones.component";
import { LorenGeofencingAllCirclesResolver } from "./resolvers/loren-geofencing-all-circles-resolver/loren-geofencing-all-circles.resolver";
import { LorenDialogModule } from "../../shared/modules/loren-dialog/loren-dialog.module";
import { LorenShapeCreationDialogComponent } from "./components/loren-shape-creation-dialog/loren-shape-creation-dialog.component";
import { LorenGeofencingAllPolygonsResolver } from "./resolvers/loren-geofencing-all-polygons-resolver/loren-geofencing-all-polygons.resolver";
import { LorenMapZonesListComponent } from "./components/loren-map-zones-list/loren-map-zones-list.component";
import { LorenExpansionPanelModule } from "../../shared/modules/loren-expansion-panel/loren-expansion-panel.module";

import { LorenLayerSelectionModule } from "../../shared/modules/loren-layer-selection/loren-layer-selection.module";
import { LorenSharedDirectivesModule } from "../../shared/directives/loren-shared-directives.module";
import { LorenPageContentComponent } from "../../shared/modules/loren-page-content/loren-page-content.component";
import {MatCardTitle} from "@angular/material/card";

@NgModule({
  declarations: [
    LorenMapZonesComponent,
    LorenShapeCreationDialogComponent,
    LorenMapZonesListComponent,
  ],
  providers: [
    LorenGeofencingAllCirclesResolver,
    LorenGeofencingAllPolygonsResolver,
  ],
    imports: [
        CommonModule,
        LeafletModule,
        LeafletDrawModule,
        LeafletMarkerClusterModule,
        MatButtonModule,
        MatIconModule,
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,
        MatListModule,
        MatTooltipModule,
        TranslocoModule,
        LorenGeofencingRoutingModule,
        LorenDialogModule,
        LorenExpansionPanelModule,
        LorenLayerSelectionModule,
        LorenSharedDirectivesModule,
        LorenPageContentComponent,
        MatButton,
        MatCardTitle,
    ],
})
export class LorenGeofencingModule {}
